import { Outlet, Link, NavLink, useNavigate } from 'react-router-dom';
import { LogOut, LayoutDashboard, FileText, Mail, Briefcase, Star, Images, ShieldCheck, KeyRound, MessageSquare } from 'lucide-react';
import { clearAuth, getAdmin } from '@/lib/auth';
import { useEffect, useState } from 'react';

export default function AdminLayout() {
  const navigate = useNavigate();
  const [admin, setAdmin] = useState(null);

  useEffect(() => { setAdmin(getAdmin()); }, []);

  const logout = () => {
    clearAuth();
    navigate('/admin/login');
  };

  const navItems = [
    { to: '/admin', label: 'Tableau de bord', icon: LayoutDashboard, end: true },
    { to: '/admin/devis', label: 'Devis', icon: FileText },
    { to: '/admin/contacts', label: 'Contacts', icon: Mail },
    { to: '/admin/candidatures', label: 'Candidatures', icon: Briefcase },
    { to: '/admin/avis', label: 'Avis', icon: Star },
    { to: '/admin/galerie', label: 'Galerie', icon: Images },
    { to: '/admin/chat', label: 'Chat IA', icon: MessageSquare },
    { to: '/admin/profil', label: 'Mon compte', icon: KeyRound },
  ];

  return (
    <div className="min-h-screen bg-anthracite-100/40">
      <header className="bg-white border-b sticky top-0 z-30">
        <div className="container-app py-3 flex items-center justify-between">
          <Link to="/admin" className="flex items-center gap-2">
            <div className="h-9 w-9 rounded-xl bg-gradient-to-br from-brand-600 to-brand-800 flex items-center justify-center">
              <ShieldCheck className="h-5 w-5 text-white" />
            </div>
            <div className="hidden sm:block leading-tight">
              <div className="font-heading font-semibold text-anthracite-950 text-sm">Espace Administrateur</div>
              <div className="text-xs text-muted-foreground">Groupe Ambulances Beaulon</div>
            </div>
          </Link>
          <div className="flex items-center gap-3">
            <span className="text-sm text-anthracite-700 hidden sm:block">{admin?.email}</span>
            <Link to="/" className="text-sm text-brand-700 hover:underline hidden sm:inline">Voir le site</Link>
            <button onClick={logout} className="inline-flex items-center gap-2 rounded-lg border bg-white px-3 py-2 text-sm font-medium hover:bg-anthracite-100" data-testid="admin-logout-button">
              <LogOut className="h-4 w-4" /> Déconnexion
            </button>
          </div>
        </div>
      </header>

      <div className="container-app py-6 grid lg:grid-cols-[240px_1fr] gap-6">
        <aside className="lg:sticky lg:top-20 self-start" data-testid="admin-sidebar-nav">
          <nav className="flex lg:flex-col gap-1 overflow-x-auto bg-white border rounded-2xl p-2">
            {navItems.map(item => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `flex items-center gap-2 px-3 py-2.5 rounded-lg text-sm font-medium whitespace-nowrap ${
                    isActive ? 'bg-brand-50 text-brand-700' : 'text-anthracite-700 hover:bg-anthracite-100'
                  }`
                }
                data-testid={`admin-nav-${item.to.split('/').pop() || 'dashboard'}`}
              >
                <item.icon className="h-4 w-4" />
                {item.label}
              </NavLink>
            ))}
          </nav>
        </aside>
        <main>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
